import { render, staticRenderFns } from "./publicProp.vue?vue&type=template&id=f3785082&scoped=true&"
import script from "./publicProp.vue?vue&type=script&lang=ts&"
export * from "./publicProp.vue?vue&type=script&lang=ts&"
import style0 from "./publicProp.vue?vue&type=style&index=0&id=f3785082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3785082",
  null
  
)

export default component.exports